const STORAGE_KEY = 'zoopup_admin_theme';

export function getAdminTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (e) {
    /* ignore */
  }
  return 'light';
}

function syncVuetifyTheme(isDark) {
  try {
    const vue = window.__adminVue;
    if (vue && vue.$vuetify && vue.$vuetify.theme) {
      vue.$vuetify.theme.dark = isDark;
    }
  } catch (e) {
    /* ignore */
  }

  document.querySelectorAll('.v-application').forEach(el => {
    el.classList.toggle('theme--dark', isDark);
    el.classList.toggle('theme--light', !isDark);
  });
}

export function resyncAdminTheme() {
  syncVuetifyTheme(getAdminTheme() === 'dark');
}

export function applyAdminTheme(theme) {
  const next = theme === 'dark' ? 'dark' : 'light';
  const isDark = next === 'dark';
  const body = document.body;
  if (!body) return next;

  body.classList.remove('admin-theme-light', 'admin-theme-dark');
  body.classList.add(isDark ? 'admin-theme-dark' : 'admin-theme-light');
  body.classList.toggle('dark_version', isDark);
  body.classList.toggle('light_version', !isDark);

  syncVuetifyTheme(isDark);

  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch (e) {
    /* ignore */
  }

  window.dispatchEvent(new CustomEvent('admin-theme-changed', { detail: { theme: next } }));

  return next;
}

export function toggleAdminTheme() {
  const next = getAdminTheme() === 'dark' ? 'light' : 'dark';
  return applyAdminTheme(next);
}

export function initAdminTheme() {
  return applyAdminTheme(getAdminTheme());
}
